// Admin dashboard: quick links to categories, families, items, leads, quotation requests

import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const AdminDashboard = () => (
  <div>
    <h1 className="text-2xl font-bold mb-6">Admin dashboard</h1>
    <div className="flex flex-wrap gap-4">
      <Button asChild><Link to="/store/admin/categories">Categories</Link></Button>
      <Button asChild><Link to="/store/admin/product-families">Product families</Link></Button>
      <Button asChild><Link to="/store/admin/sourcing-items">Sourcing items</Link></Button>
      <Button asChild variant="outline"><Link to="/store/admin/leads">Leads</Link></Button>
      <Button asChild variant="outline"><Link to="/store/admin/quotation-requests">Quotation requests</Link></Button>
    </div>
  </div>
);

export default AdminDashboard;
